export default __webpack_public_path__ + "237e208bdeb39773c0ee85baa9ed47ce.svg";